exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-gops.js
// module id = ./node_modules/core-js/modules/_object-gops.js
// module chunks = vendor